import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeScooter = function SvgLargeScooter(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 69 69",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.256 55.587a2.71 2.71 0 100-5.42 2.71 2.71 0 000 5.42zm0 4a6.71 6.71 0 100-13.42 6.71 6.71 0 000 13.42zM54.269 55.587a2.683 2.683 0 100-5.366 2.683 2.683 0 000 5.366zm0 4a6.683 6.683 0 100-13.366 6.683 6.683 0 000 13.366z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M48.254 6.955a2 2 0 01.123 2.825l-3.18 3.472 9.216 33.321a2 2 0 01-3.855 1.066l-.706-2.55a54.073 54.073 0 01-1.562 2.217c-1.146 1.54-2.495 3.156-3.907 4.406-1.329 1.175-3.086 2.367-5.016 2.367H19.786v-2-2h19.581c.372 0 1.165-.3 2.365-1.363 1.116-.987 2.276-2.355 3.35-3.798a55.524 55.524 0 002.666-3.957c.266-.43.488-.804.66-1.096L41.045 13.25a2 2 0 01.453-1.884l3.929-4.288a2 2 0 012.826-.123zM19.785 52.079v-2a2 2 0 100 4v-2z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.776 43.641c6.879-2.875 13.31 1.844 14.172 8.168a2 2 0 11-3.964.54c-.55-4.036-4.498-6.76-8.666-5.017a2 2 0 01-1.542-3.69z",
    clipRule: "evenodd"
  }));
};

export default SvgLargeScooter;